import { api } from './index';
export const currencyValuesApi = { index() { const path = '/api/internal/currency_values'; return api({ method: 'get', url: path }).then(response => response.data); } };
